import { Notifications as NotificationIcon } from '@mui/icons-material';
import { useNotifications } from 'components/Header/components/Notifications/hooks';
import { Box, IconButton } from '@mui/material';
import { NotificationPopover } from 'components/Header/components/Notifications/NotificationPopover.tsx';

export const Notifications = () => {
  const {
    isOpen,
    handleOpen,
    handleClose,
    id,
    anchorEl,
    unreadNotificationCount,
  } = useNotifications();

  return (
    <>
      <IconButton sx={{ position: 'relative' }} onClick={handleOpen}>
        <NotificationIcon sx={{ width: 24, height: 24 }} color='primary' />
        {unreadNotificationCount > 0 && (
          <Box
            sx={{
              boxSizing: 'border-box',
              position: 'absolute',
              height: 12,
              width: 12,
              border: theme => `2px solid ${theme.palette.common.white}`,
              bgcolor: theme => theme.palette.error.main,
              borderRadius: '50%',
              right: 6,
              bottom: 6,
              cursor: 'pointer',
            }}
          />
        )}
      </IconButton>

      {anchorEl && (
        <NotificationPopover
          isOpen={isOpen}
          id={id}
          anchorEl={anchorEl}
          onClose={handleClose}
          unreadNotificationCount={unreadNotificationCount}
        />
      )}
    </>
  );
};
